import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { landingPageEmpresa } from '@ibk/shared-assets';
import { HeroLayout } from '@ibk/shared-layout';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Icon } from '@ibk/shared-ui';
import { BenefitsLandingContent } from '../../components/BenefitsLandingContent';
import { beneficiosTranslations } from '../../translations';
import { NetworkPage } from '../NetworkPage';
import styles from './components/NetworkLink.module.css';
function LandingPageClientContent({ heroImage = landingPageEmpresa, onContract }) {
    const { t } = useTranslation();
    const [isNetworkModalOpen, setIsNetworkModalOpen] = useState(false);
    const clientFeatures = [
        {
            icon: _jsx(Icon, { name: 'recharge' }),
            title: t('benefits.landing.features.automation.title'),
            description: t('benefits.landing.features.automation.description'),
        },
        {
            icon: _jsx(Icon, { name: 'currency' }),
            title: t('benefits.landing.features.single-card-balances.title'),
            description: t('benefits.landing.features.single-card-balances.description'),
        },
        {
            icon: _jsx(Icon, { name: 'food' }),
            title: t('benefits.landing.features.accredited-network.title'),
            description: t('benefits.landing.features.accredited-network.description'),
        },
        {
            icon: _jsx(Icon, { name: 'listCheck' }),
            title: t('benefits.landing.features.zero-cost.title'),
            description: t('benefits.landing.features.zero-cost.client.description'),
        },
        {
            icon: _jsx(Icon, { name: 'featureIsencao' }),
            title: t('benefits.landing.features.charge-exemption.title'),
            description: t('benefits.landing.features.charge-exemption.client.description'),
        },
        {
            icon: _jsx(Icon, { name: 'featureSeguranca' }),
            title: t('benefits.landing.features.legal-security.title'),
            description: t('benefits.landing.features.legal-security.client.description'),
        },
        {
            icon: _jsx(Icon, { name: 'featureComodidade' }),
            title: t('benefits.landing.features.digital-account.title'),
            description: t('benefits.landing.features.digital-account.description'),
        },
    ];
    const handleContractClick = useCallback(() => {
        if (onContract) {
            onContract();
        }
        else {
            console.log('Contract button clicked - LandingPageClient');
        }
    }, [onContract]);
    const handleOpenNetworkModal = useCallback(() => {
        setIsNetworkModalOpen(true);
    }, []);
    const handleCloseNetworkModal = useCallback(() => {
        setIsNetworkModalOpen(false);
    }, []);
    return (_jsxs(HeroLayout, { heroImage: heroImage, variant: 'client', heroText: {
            title: t('benefits.landing.hero.title'),
            subtitle: t('benefits.landing.hero.subtitle'),
            titleFirstWordBold: true,
        }, children: [_jsx(BenefitsLandingContent, { title: t('benefits.landing.client.title'), features: clientFeatures, titleCentered: true, variant: 'client', actions: {
                    primaryButton: {
                        text: t('benefits.landing.actions.contract-button'),
                        onClick: handleContractClick,
                    },
                    showSeparator: false,
                }, networkLink: _jsxs("button", { onClick: handleOpenNetworkModal, className: styles.networkLink, "data-testid": 'landing-network-link', children: [_jsx(Icon, { name: 'store', className: styles.networkLinkIcon }), _jsx("span", { children: t('benefits.landing.viewNetwork') })] }) }), _jsx(NetworkPage, { isOpen: isNetworkModalOpen, onClose: handleCloseNetworkModal, "data-testid": 'NetworkModal' })] }));
}
export const LandingPageClient = props => {
    return (_jsx(TranslationProvider, { translations: beneficiosTranslations, defaultLanguage: 'pt-BR', children: _jsx(LandingPageClientContent, { ...props }) }));
};
